import { Filter } from '../common/filter';
import { TYPE_DIMENSIONS } from './type-dimensions';
import { DEFAULT_STAT_LIMIT } from '../common/config';

export class CurrentFilterService {
  constructor(
    PermissionService,
    FiltersService,
    CurrentModelService,
  ) {
    this.FiltersService = FiltersService;
    this.CurrentModelService = CurrentModelService;
    this.defaultDimension = window.defaultDimension ||
      'agent_account@user_name:user_name';
    this.filterBar = new Filter('Bar');
    this.filterBar.setDrilldown(this.defaultDimension);
    this.filterBar.skipStat = window.aggregate_show_stat;
    this.filter = null;


    this.timeFrom = new Date();
    this.timeTo = new Date(this.timeFrom.valueOf());
    this.timeFrom.setHours(0, 0, 0, 0);
    this.timeTo.setHours(23, 59, 59, 999);

    this.panel = PermissionService.filterConstructor ? 'constructor' : 'catalog';
    this.visibleDimensions = [];
  }

  createNewFilter(name) {
    let filter = new Filter(name);
    while (this.FiltersService.find(f => f.name === filter.name)) {
      let parts = filter.name.split(' ');
      if (parts.length > 1) {
        let idx = '1';
        if (parseInt(parts[parts.length - 1])) {
          idx = parseInt(parts[parts.length - 1]) + 1;
          parts.pop();
        }
        filter.name = parts.join(' ') + ' ' + idx;
      } else {
        filter.name = parts[0] + ' 1';
      }
    }
    return filter;
  }

  newFilter(name) {
    this.filter = this.createNewFilter(name);
  }

  rebuildVisibleDimensions() {
    let dims;
    if (this.filter && this.filter.filters && this.filter.filters.length > 0) {
      let selected = this.filter.filters.filter(f =>
      f['dimension'] === 'agent_eventtype@default:agent_eventtype')
        .map(f => f['value']);
      dims = selected.map(key_selected => TYPE_DIMENSIONS[key_selected])
        .reduce((prev, curr) => prev.concat(
          curr.filter(dim => prev.indexOf(dim) === -1)), []);
    }
    if (dims && dims.length) {
      this.visibleDimensions = this.CurrentModelService.model.dimensions
        .filter(dim => dims.indexOf(dim['name']) !== -1);
    } else {
      this.visibleDimensions = this.CurrentModelService.model ?
        this.CurrentModelService.model.dimensions : [];
    }
  }

  selectBarDim(dim) {
    this.filterBar.copyFrom(this.filter, true);
    this.filterBar.setDrilldown(dim.toString());
    this.filterBar.setOrder(dim.toString());
    this.filterBar.setKeyword('');
    this.filterBar.page = 0;
    this.filterBar.lookup = null;
  }

  getReportQuery(filterBase) {
    let filter = new Filter('Report');
    let srcFilter = filterBase || this.filter;
    filter.copyFrom(srcFilter);
    filter.filters = srcFilter.filters.slice(0);
    filter.timeFrom = this.timeFrom;
    filter.timeTo = this.timeTo;
    filter.timePeriod = this.timePeriod;
    let obj = filter.buildQueryParams();
    obj['limit'] = DEFAULT_STAT_LIMIT;
    obj['threshold'] = this.threshold;

    let serialize = function (obj) {
      let str = [];
      for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
          let v = obj[p];
          if (v instanceof Date) {
            v = v.toISOString();
          }
          if (v instanceof Array) {
            for (let idx in v) {
              str.push(encodeURIComponent(p) + '=' + encodeURIComponent(v[idx]));
            }
          } else str.push(encodeURIComponent(p) + '=' + encodeURIComponent(v));
        }
      }
      return str.join('&');
    };

    return serialize(obj);
  }

  getReportUrl(filter) {
    if (!filter || !filter.url) {
      return null;
    }
    let base = filter.url;
    return `${base}?${this.getReportQuery(filter)}`;
  }

  generateReport(url) {
    this.filter.setMode('reports');
    this.filter.url = url;
  }

  openFrame(url) {
    this.frameUrl = url;
  }

  reset() {
    this.frameUrl = null;
  }

  buildCardFilter() {
    let criterion = this.filter.filters[0];
    if (!criterion) {
      console.error('card filter should have at least one criterion');
      return;
    }
    let cardFilter = this.FiltersService.getCardFilter(criterion.dimension);
    if (cardFilter) {
      this.filter.children = angular.copy(cardFilter.children);
    } else {
      this.filter.children = [];
    }
  }

}



// WEBPACK FOOTER //
// ./src/core/current-filter.service.js